import React from "react";
import { withPrefix } from "gatsby";

import Button from "../../atoms/button/button";
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";

import "./cardBookClub.scss";

interface CardBookClubProps {
  descripcion: any ;
  imagenPrincipal: Array<any>;
  redireccionBoton: string;
  tituloBanner: string;
  tituloBoton: string;
  tituloDescripcion: string;
  selected: boolean;
  setSelected: Function;
  index: number;
  gtmMark: string;
  cardAudio?: boolean,
  audio?: string;
  marqueeText?: string;
}

const CardBookClub = (props: CardBookClubProps) => {
  const {
    descripcion,
    imagenPrincipal,
    redireccionBoton,
    tituloBanner,
    tituloBoton,
    tituloDescripcion,
    selected,
    setSelected,
    index,
    cardAudio,
    audio,
    marqueeText
  } = props;

  return (
    <div className="m-card-book-club">
      {cardAudio ? (
        <>
          <div className="m-card-book-club__book-infoAudio">
            <img src={imagenPrincipal[0].file.url} alt={formatImageAlt(imagenPrincipal[0].title)} />
            <div className="m-card-book-club__book-info__texts">
              <h3 className="m-card-book-club__book-info__texts__name">
                {tituloBanner}
              </h3>
              <p className="m-card-book-club__book-info__texts__author">
                {tituloDescripcion}
              </p>
            </div>
          </div>
          <div className="m-card-book-club__session-infoAudio">
            <p className="m-card-book-club__session-infoAudio__session">
              {descripcion.json.content[0].content[0].value}
            </p>
            <div className="m-card-book-club__session-infoAudio__marq">
              <p>
                {marqueeText || 'Vacio'}
              </p>
              <p>
                {marqueeText || 'Vacio'}
              </p>
            </div>
            <audio id="audioCard" className="a-audio__content__audio" src={audio} preload="auto" controls></audio>
          </div>
        </>
      ) : (
      <>
        <div className="m-card-book-club__book-info">
          <img src={imagenPrincipal[0].file.url} alt={formatImageAlt(imagenPrincipal[0].title)} />
          <div className="m-card-book-club__book-info__texts">
            <h3 className="m-card-book-club__book-info__texts__name">
              {tituloBanner}
            </h3>
            <p className="m-card-book-club__book-info__texts__author">
              {tituloDescripcion}
            </p>
          </div>
        </div>
        <div className="m-card-book-club__session-info">
            <p className="m-card-book-club__session-info__session">
              {descripcion.json.content[0].content[0].value}
            </p>
            <p className="m-card-book-club__session-info__date">
              {descripcion.json.content[0].content[1].value}
            </p>
          </div>
      </>
      )}

      <div className="m-card-book-club__button-section">
        <Button
          type="link"
          classname="secondary"
          text={tituloBoton}
          isDisabled={false}
          href={withPrefix(`/libros/detalle/?book=${redireccionBoton}`)}
          gtmMark={`${props.gtmMark}LeerLibro${normalizeTwoWords(
            tituloBanner
          )}`}
        />
      </div>
      <i
        className="m-card-book-club__icon icon-ellipsis-v"
        onClick={() => setSelected(index)}
      />
      <div
        className={`m-card-book-club__menu ${
          selected ? "m-card-book-club__menu--show" : ""
        }`}
      >
        <a
          href={withPrefix(`/libros/detalle/?book=${redireccionBoton}`)}
          className={`${props.gtmMark}LeerLibro${normalizeTwoWords(
            tituloBanner
          )}`}
        >
          {tituloBoton}
        </a>
      </div>
    </div>
  );
};

export default CardBookClub;
